<template>
  <div class="entrepreneur-quote">
    <div class="entrepreneur-quote__inner">
      <!-- arrows -->
      <div class="entrepreneur-quote__inner__icons">
        <icon icon="4-arrow-up" />
      </div>
      <!-- quote -->
      <h1>{{ data.primary.quote[0].text }}</h1>
      <!-- name -->
      <h3>{{ firstName }} {{ lastName }}</h3>
    </div>
  </div>
</template>

<script>
import Icon from "objects/Icon";
export default {
  props: {
    data: {
      type: Object,
      required: true
    },
    firstName: {
      type: String,
      required: true
    },
    lastName: {
      type: String,
      required: true
    }
  },
  components: {
    Icon
  }
};
</script>

<style lang="scss" scoped>
.entrepreneur-quote {
  @include sectionColouredPadding;
  @include sharedParentBody;

  &__inner {
    max-width: 900px;
    /* background-color: blue; */
    /* height: 100%; */
    display: flex;
    flex-direction: column;
    text-align: center;
    &__icons {
      display: flex;
      justify-content: center;
      &::v-deep svg {
        max-width: 40vw;
        max-height: 40vw;
        width: 100%;
        stroke: $color-dark;
        stroke-width: 12px;
        @media #{$breakpoint-horizontal} {
          max-width: 250px;
        }
      }
    }
    h1 {
      @include t1-heavy;
      color: $color-bright;
      padding-top: var(--grid-gutter);
      @media #{$breakpoint-horizontal} {
        padding-top: var(--grid-gutter-double);
      }
    }
    h3 {
      @include t3-heavy-bold;
      color: $color-dark;
      padding-top: var(--grid-gutter);
    }
  }
}
</style>
